export const PAGE_META = {
    TAKE_FIVE_DAILY: {
        title: 'Take 5 Daily: A Thorne Magazine | Thorne'
    },
    NEWSROOM: {
        title: 'Newsroom & Press | Thorne'
    },
    FAQ: {
        title: 'Frequently Asked Questions | Thorne'
    },
    PRODUCT_LISTING: {
        title: 'Supplements & Tests | Thorne'
    },
} as const;
